
export default function InitialData({ children }) {

  return (<>{children}</>);
}